export const aboutData = {
  welcomeMessage: {
    title: "Welcome to Your Sanctuary",
    content: "Kirstie creates a gentle, earthy container where transformation can unfold without rush. Her approach is warm, practical, and deeply respectful of your inner wisdom — she is here to help you remember your light, steady your heart, and guide you back into a life that feels true."
  },

  personalStory: {
    title: "Meet Kirstie",
    paragraphs: [
      "Kirstie is a holistic healer and lightworker who has spent over three decades holding space for people—first as a nurse, and now as a guide for those moving from overwhelm into ease. She has supported hundreds of women and men through low seasons of life, helping them find their way back to more flow, presence, and abundance.",
      "Her own path brought her here. After years of caring for others while raising a family, Kirstie faced her own deep struggle with postnatal depression, trauma and major life changes. In those tender, difficult times, she felt very alone — and it was there she began a quiet, committed journey into healing.",
      "From 2017 onward, practices like forgiveness, meditation, clear boundaries, and heart-centred presence reshaped her life. What felt broken slowly revealed its wisdom. With patience and steady practice, fear softened, and space opened for abundance, compassion, and a renewed sense of self.",
      "Her work blends soul-led intuition with grounded tools. Kirstie draws on intuitive Reiki, chakra balancing, guided meditation, spiritual life coaching, tarot, oracle cards, energy clearing, and bespoke ceremonies to support lasting change. Each offering is guided by compassion and tuned to the unique needs of the person in front of her — whether you're seeking somatic release, nervous-system regulation, clarity, or re-alignment with your purpose.",
      "If you're curious to explore one-on-one healing, join a sound bath, or attend a restorative class, you're welcome here. Let Kirstie tend your inner flame together with you."
    ]
  },

  qualifications: [
    {
      title: "Reiki Master Teacher",
      organization: "Usui Reiki",
      year: null
    },
    {
      title: "Spiritual Life Coaching Diploma",
      credential: "SLC Dip",
      year: null
    },
    {
      title: "Chakra Healer Master Diploma",
      credential: "CCHM Dip",
      year: null
    },
    {
      title: "Tarot Counsellor",
      organization: "Biddy Tarot Certified",
      year: null
    },
    {
      title: "Restorative Yin Instructor",
      organization: "Certified",
      year: null
    },
    {
      title: "Meditation Teacher",
      organization: "Certified",
      year: null
    }
  ],

  memberships: [
    "International Institute for Complementary Therapies",
    "Reiki Healing Association"
  ],

  callToAction: {
    title: "Ready to Begin Your Transformation?",
    text: "Let go of old patterns and embrace self-love. Book a free 15-minute discovery call to see how Kirstie can support your journey.",
    buttonText: "Book Free Discovery Call"
  },

  philosophy: {
    title: "Kirstie's Approach to Healing",
    points: [
      "Kirstie believes in addressing root causes, not just symptoms",
      "Every healing journey is unique and personalised",
      "Combining ancient wisdom with modern techniques",
      "Creating a safe, non-judgmental space for transformation",
      "Empowering you with tools for ongoing self-healing"
    ]
  }
};
